import { render, staticRenderFns } from "./ComplianceDetails.vue?vue&type=template&id=ef2bed64&scoped=true"
import script from "./ComplianceDetails.vue?vue&type=script&lang=js"
export * from "./ComplianceDetails.vue?vue&type=script&lang=js"
import style0 from "./ComplianceDetails.vue?vue&type=style&index=0&id=ef2bed64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2bed64",
  null
  
)

export default component.exports